export default __webpack_public_path__ + "static/media/interface-10.af6d3ed4.png";